import { Component, OnInit, Input} from '@angular/core';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { FormGroup, FormControl, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { QuizData } from '../QuizData';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
// import { routerNgProbeToken } from '@angular/router/src/router_module';
// import { userInfo } from 'os';
import { environment } from 'src/environments/environment';
import * as Parse from 'parse';
import { CookieService } from 'ngx-cookie-service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalContent } from '../../alert-component';
import { UserData } from 'src/app/model/UserData';

@Component({
  selector: 'app-registerprogramgoals',
  templateUrl: './registerprogramgoals.component.html',
  styleUrls: ['./registerprogramgoals.component.css']
})
export class RegisterprogramgoalsComponent implements OnInit {
  programGoalsForm : FormGroup;
  submitted: boolean = false;
  activityGoal : string = "";
  weightGoal : string = "";
  activitycaloriesGoal : string = "";
  foodcaloriesGoal : string = "";
  stepGoal : string = "";
  // userId;
  
  successMessage: string;
  failedMessage: string;
  constructor(
    private route: ActivatedRoute,
    private cookie : CookieService,
    private router: Router,
    private  _bkoffService: BackOffServiceService,
    private formBuilder : FormBuilder,
    private modalService: NgbModal
    ) {
      Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
      (Parse as any).serverURL = environment.serverURL;
    }

  ngOnInit() {
    let regexPatterns = {
      // this can be improved
      activity: "^[0-9]+$",
      weight: "^[0-9]+$",
      activitycalories : "^[0-9]+$",
      foodcalories : "^[0-9]+$",
      step: "^[0-9]+$"
   };
    this.programGoalsForm  =  this.formBuilder.group({
  
      activity: ['', [Validators.required, Validators.pattern(regexPatterns.activity)]],
      activitycalories: ['', [Validators.required, Validators.pattern(regexPatterns.activitycalories)]],
      foodcalories: ['', [Validators.required, Validators.pattern(regexPatterns.foodcalories)]],
      weight: ['', [Validators.required, Validators.pattern(regexPatterns.weight)]],
      step: ['', [Validators.required, Validators.pattern(regexPatterns.step)]],
    });

    this._bkoffService.getWeightGoal().then((res) => {
      this.weightGoal = res.toString();
    })

    this._bkoffService.getActivityGoal().then((res) => {
      this.activityGoal = res.toString();
    })

    this._bkoffService.getActivityGoalCoach().then((res) => {
      this.activityGoal = res.toString();
    })

    this._bkoffService.getFoodCaloriesGoal().then((res) => {
      this.foodcaloriesGoal = res.toString();
    })

    this._bkoffService.getActivityCaloriesGoal().then((res) => {
      this.activitycaloriesGoal = res.toString();
    })

    this._bkoffService.getActivityCaloriesGoalCoach().then((res) => {
      this.activitycaloriesGoal = res.toString();
    })

    this._bkoffService.getStepGoal().then((res) => {
      this.stepGoal = res.toString();
    })

    // this.route.paramMap.subscribe(params => {
    //   this.userId = params.get('userId');
    // });
    // console.log(this.userId);
  }

  get fmBuilder() { return this.programGoalsForm.controls; }


  getFormControl(name:any) {
    return this.programGoalsForm.get(name);
  }
  

  reset(){
    this.programGoalsForm.reset({PersonalData: new QuizData()});
  }

  getFormValidationErrors() {
    var missingInput = false;
    Object.keys(this.programGoalsForm.controls).forEach(key => {
    const controlErrors: ValidationErrors = this.programGoalsForm.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            if (keyError === "required"){
              missingInput = true;
            }
          });
        }
      });
      return missingInput;
    }

  btnclick(){
    // const result: UserData = Object.assign({}, this.programGoalsForm.value);
    // let fromResult = Object.assign({}, result);

    console.log("about to check form validation");
    // stop here if form is invalid    
    if (this.programGoalsForm.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'You have left a question unanswered';
      }
      else{
        modalRef.componentInstance.name = 'Please make sure you have formatted all your inputs correctly';
      }
      return;
    }


      this.submitted = true;
      console.log("past validation");

      const signUpData = this.programGoalsForm;
      var userInfo = new UserData()

      userInfo.weightGoal = Number(signUpData.get(['weight']).value)
      userInfo.activityGoal = Number(signUpData.get(['activity']).value)
      userInfo.stepsGoal = Number(signUpData.get(['step']).value)
      userInfo.activitycaloriesGoal = Number(signUpData.get(["activitycalories"]).value)
      userInfo.foodcaloriesGoal = Number(signUpData.get(["foodcalories"]).value)
      userInfo.aCode = this.cookie.get("program");
      userInfo.program_id = this.cookie.get('program_id');

      console.log(signUpData.get(['weight']).value)
      console.log(signUpData.get(['activity']).value)
      console.log(signUpData.get(['step']).value)

      this._bkoffService.setProgramgoals(userInfo);

      console.log("btnclick registered");
      
      this.router.navigateByUrl('/phoneandemail');
       console.log("navigated");
    
  };
}

